/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ComponentJsonRoot } from '../models/component-json-root';

@Injectable({
  providedIn: 'root',
})
export class PurviewConfigurationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getPurviewComponentJs
   */
  static readonly GetPurviewComponentJsPath = '/config-api/component-json';

  /**
   * GET Tenant specific Component JSON.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPurviewComponentJs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurviewComponentJs$Response(params?: {

    /**
     * The tenant name we will use as a key to lookup their config in MongoDB. Falls-back to default config if specified tenant not found.
     */
    tenant?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ComponentJsonRoot>> {

    const rb = new RequestBuilder(this.rootUrl, PurviewConfigurationService.GetPurviewComponentJsPath, 'get');
    if (params) {
      rb.query('tenant', params.tenant, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ComponentJsonRoot>;
      })
    );
  }

  /**
   * GET Tenant specific Component JSON.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPurviewComponentJs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurviewComponentJs(params?: {

    /**
     * The tenant name we will use as a key to lookup their config in MongoDB. Falls-back to default config if specified tenant not found.
     */
    tenant?: string;
  },
  context?: HttpContext

): Observable<ComponentJsonRoot> {

    return this.getPurviewComponentJs$Response(params,context).pipe(
      map((r: StrictHttpResponse<ComponentJsonRoot>) => r.body as ComponentJsonRoot)
    );
  }

}
